<div class="glo-contact-info-slider-container apple">
  <div class="modal-backdrop" (click)="close()" *ngIf="visible" [@fadeInOnEnter] [@fadeOutOnLeave]></div>
  <div class="glo-contact-info-slider">
    <div class="modal-dialog " role="document" *ngIf="visible" [@slideInUpOnEnter] [@slideOutDownOnLeave]>

      <div class="modal-content p-0 pb-5">
        <div class="d-flex justify-content-end">
          <button type="button" class="close-btn" (click)="close()" aria-label="Close">
            <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 24px;">
              <use href="assets/sprite.view.svg#glo-close-2"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body p-0 mx-20px">
          <h2 id="contactInfoSlider-label" class="highlight-2 text-center m-0">Need help?</h2>
          <p class="content-3 m-0 mt-2">
            We're available at {{phoneNumber | formatPhone}} Monday-Friday 5 a.m.-7 p.m. PT and weekends <span class="text-nowrap"> 7 a.m.-4 p.m. PT.</span>
          </p>

          <div class="mt-4">
            <div class="hide-when-chat-has-no-capacity">
              <a [href]="phoneNumber | formatPhone:'link'" (click)="close()" class="btn btn-block btn-action">
                Call us
              </a>

              <button 
                (click)="onClick_chatButton()" 
                class="btn btn-block btn-outline mt-2">
                Chat now
              </button>
            </div>
            <div class="hide-when-chat-has-capacity">
              <a href='/contact-us' target="_blank" class="btn btn-block btn-action primaryCta">
                Email us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
